import { render, staticRenderFns } from "./Fotocheck.vue?vue&type=template&id=947ae814&scoped=true"
import script from "./Fotocheck.vue?vue&type=script&lang=js"
export * from "./Fotocheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947ae814",
  null
  
)

export default component.exports